import React from 'react';
import PropTypes from 'prop-types';
import { CardItem } from '../../../Card/CardItem';
import { contentPackageLeadStyle } from '../style/contentPackageLeadStyle';
import { getContentPackageStackCardDatum } from './utils/contentPackageUtils';
import { ContentPackageHeaderSection } from '../ContentPackageHeaderSection';
import { Container } from '../../../responsive/atoms/Container';

export const ContentPackageTemplate1 = ({ data, isAboveTheFold }) => {
  const stackCardDatum = getContentPackageStackCardDatum(data);

  const stylesLead = stackCardDatum[0]
    ? contentPackageLeadStyle(
        data.backgroundColor,
        data.stack[0].entity.tint,
        data.stack[0].entity.gradient
      )
    : null;

  const hasHeaderSection = !!(data.contentPackageHeader || data.description);

  return (
    <Container margin="0 auto" backgroundColor={data.backgroundColor}>
      <Container
        maxWidth="100rem"
        padding={
          hasHeaderSection
            ? ['0 0 40px 0', '0 0 56px 0', '0 0 56px 0', '0 70px 80px 70px']
            : ['40px 0', '56px 0', '56px 0', '80px 70px']
        }
      >
        {hasHeaderSection && (
          <ContentPackageHeaderSection
            title={data.contentPackageHeader}
            description={data.description}
          />
        )}
        {stackCardDatum[0] && (
          <CardItem
            styles={stylesLead}
            data={stackCardDatum[0]}
            aspect="16x9"
            isAboveTheFold={isAboveTheFold}
          />
        )}
      </Container>
    </Container>
  );
};

ContentPackageTemplate1.defaultProps = {
  isAboveTheFold: false
};

ContentPackageTemplate1.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isAboveTheFold: PropTypes.bool
};
